module.exports = __webpack_public_path__ + "img/coverLogo1.8d44bea2.jpg";